export default {"src":"/_next/static/media/live_brackets_upcoming_badge.7849189f.svg","height":21,"width":80,"blurWidth":0,"blurHeight":0};